import { FaBars } from "react-icons/fa";
import Sidebar from "./Sidebar";
import { useEffect, useState } from "react";
import { db } from "./Firebase";

export default function Settings() {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const [businessInfo, setBusinessInfo] = useState({
        businessname: "",
        phone: "",
        address: "",
        email: "",
    });

    const [socialmedia, setsocialmedia] = useState({
        Instagram: "",
        Whatsapp: "",
    });

    const [docId, setDocId] = useState(null);
    const [social, setsocial] = useState(null);

    // Fetch Business Info
    useEffect(() => {
        db.collection("businessinfo")
            .limit(1)
            .get()
            .then((snapshot) => {
                snapshot.forEach((doc) => {
                    setBusinessInfo(doc.data());
                    setDocId(doc.id);
                });
            });
    }, []);

    // Fetch Social Media Info
    useEffect(() => {
        db.collection("socialmedia")
            .limit(1)
            .get()
            .then((snapshot) => {
                snapshot.forEach((doc) => {
                    setsocialmedia(doc.data());
                    setsocial(doc.id);
                });
            });
    }, []);

    // Save / Update Business Info
    function submitBusinessData(e) {
        e.preventDefault();

        if (docId) {
            db.collection("businessinfo").doc(docId).update(businessInfo);
            alert("Business Info Updated ✅");
        } else {
            db.collection("businessinfo").add(businessInfo).then((docRef) => {
                setDocId(docRef.id);
                alert("Business Info Saved ✅");
            });
        }
    }

    // Save / Update Social Media
    function submitSocialmedia(e) {
        e.preventDefault();

        if (social) {
            db.collection("socialmedia").doc(social).update(socialmedia);
            alert("Social Media Links Updated ✅");
        } else {
            db.collection("socialmedia").add(socialmedia).then((docRef) => {
                setsocial(docRef.id);
                alert("Social Media Links Saved ✅");
            });
        }
    }

    // Handle Business Info Change
    function handleChange(e) {
        setBusinessInfo({ ...businessInfo, [e.target.name]: e.target.value });
    }

    // Handle Social Media Change
    function handleChangee(e) {
        setsocialmedia({ ...socialmedia, [e.target.name]: e.target.value });
    }

    return (
        <>
            <div className="container-fluid p-0">
                <div className="row g-0">
                    <Sidebar />
                    {/* Main Content */}
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 offset-0 offset-lg-0 offset-md-0 ps-5">

                        <div className="container-fluid my-1 ps-5">
                            <div className="row g-4">
                                {/* Business Info */}
                                <div className="col-md-6">
                                    <div className="card shadow-sm border-0">
                                        <div className="card-body">
                                            <h5 className="card-title mb-3">Business Information</h5>
                                            <form onSubmit={submitBusinessData}>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <div className="mb-2 col-6 me-1">
                                                        <label className="form-label">Business Name</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="businessname"
                                                            value={businessInfo.businessname}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    <div className="mb-2 col-6">
                                                        <label className="form-label">Phone</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="phone"
                                                            value={businessInfo.phone}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="mb-2">
                                                    <label className="form-label">Address</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows="2"
                                                        name="address"
                                                        value={businessInfo.address}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="mb-2">
                                                    <label className="form-label">Email</label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        name="email"
                                                        value={businessInfo.email}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <button type="submit" className="btn btn-primary w-100">
                                                    {docId ? "Update Business Info" : "Save Business Info"}
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                </div>

                                {/* Social Media Links */}
                                <div className="col-md-6">
                                    <div className="card shadow-sm border-0">
                                        <div className="card-body">
                                            <h5 className="card-title mb-3">Social Media Links</h5>
                                            <form onSubmit={submitSocialmedia}>
                                                <div className="mb-3">
                                                    <label className="form-label">Instagram</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="Instagram"
                                                        placeholder="https://instagram.com/h98denims"
                                                        value={socialmedia.Instagram}
                                                        onChange={handleChangee}
                                                    />
                                                </div>
                                                <div className="mb-3">
                                                    <label className="form-label">WhatsApp</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="Whatsapp"
                                                        placeholder="+91 9876543210"
                                                        value={socialmedia.Whatsapp}
                                                        onChange={handleChangee}
                                                    />
                                                </div>
                                                <button type="submit" className="btn btn-primary w-100">
                                                    {social ? "Update Social Links" : "Save Social Links"}
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
